require('../../modules/es.array.iterator');
require('../../modules/es.object.from-entries');
var path = require('../../internals/path');

module.exports = path.Object.fromEntries;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/object/from-entries.js
// module id = 1222
// module chunks = 1